export const customTextFiled = {
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#D1D5DB",
      color: "#6B7280",
    },
    "&:hover fieldset": {
      borderColor: "#D1D5DB",
      color: "#6B7280",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#D1D5DB",
      color: "#6B7280",
    },
  },
};

export const placeholderStye = {
  sx: {
    "&::placeholder": {
      color: "#6B7280",
      opacity: 1,
    },
  },
};

export const clientGrey = {
  900: "#111928",
  500: "#6B7280",
  300: "#D1D5DB",

  100: "#F9FAFB",
};

export const dateStyle = {
  width: "100%",
  color: "#6B7280",
  backgroundColor: clientGrey[100],
  "& .MuiInputBase-input": {
    padding: "12px 14px",
    fontSize: "16px",
  },
  "& .MuiInputBase-root": {
    // backgroundColor: "#6B7280",
    borderRadius: "8px",
    borderColor: "#D1D5DB !important",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "#D1D5DB !important",
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "#D1D5DB !important",
  },
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: "#D1D5DB !important",
  },
};

export const dateSlotStyle = {
  textField: {
    inputProps: {
      placeholder: "Select Date of Birth",
      sx: {
        padding: "12px",
        fontSize: "16px",
        color: "#6B7280",
        "&:hover .MuiOutlinedInput-notchedOutline": {
          borderColor: "#039443 !important",
        },
        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
          borderColor: "#039443 !important",
        },
        "@media (max-width: 600px)": {
          padding: "10px",
          fontSize: "14px",
        },
      },
    },
  },
  day: {
    sx: {
      "&.MuiPickersDay-root.Mui-selected": {
        backgroundColor: "#039443!important",
        color: "#ffffff",
        "&:hover": {
          backgroundColor: "#028835 !important",
          color: "#ffffff",
        },
      },
      "&.MuiPickersDay-root:hover": {
        backgroundColor: "rgba(3, 148, 67, 0.08)",
        // color: client.primary,
      },
      "&.MuiPickersDay-root.Mui-disabled": {
        color: clientGrey[300],
      },
      "@media (max-width: 600px)": {
        "&.MuiPickersDay-root.Mui-selected": {
          backgroundColor: "#039443 !important",
          color: "#ffffff !important",
        },
        "&.MuiPickersDay-root:hover": {
          backgroundColor: "rgba(3, 148, 67, 0.08) !important",
          // color: client.primary,
        },
      },
    },
  },
  desktopPaper: {
    sx: {
      ".MuiPickersYear-yearButton.Mui-selected": {
        backgroundColor: "#039443 !important",
        color: "#ffffff !important",
        "&:hover": {
          backgroundColor: "#028835 !important",
          color: "#ffffff !important",
        },
      },
      ".MuiPickersYear-yearButton": {
        padding: "8px 16px",
        fontSize: "16px",
        backgroundColor: "rgba(3, 148, 67, 0.07)",
        "&:hover": {
          backgroundColor: "#028835",
          color: "#ffffff",
        },
        "@media (max-width: 600px)": {
          padding: "6px 12px",
          fontSize: "14px",
        },
      },
      ".MuiPickersCalendarHeader-root": {
        // backgroundColor: "#6B7280",
        borderBottom: `1px solid ${clientGrey[200]}`,
      },
    },
  },
  popperSx: {
    "& .MuiPaper-root": {
      boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
      borderRadius: "8px",
      "@media (max-width: 600px)": {
        borderRadius: "4px",
        backgroundColor: "#6B7280",
      },
    },
  },
  yearButton: {
    sx: {
      backgroundColor: "rgba(3, 148, 67, 0.1) !important", // Light green background on hover
      color: "#039443 !important",
      "&:hover": {
        backgroundColor: "rgba(3, 148, 67, 0.1) !important",
        color: "#039443 !important",
      },
      "&:selected": {
        backgroundColor: "#039443 !important",
        color: "#ffffff !important",
      },
    },
  },
  actionBar: {
    sx: {
      "& .MuiButton-root": {
        color: "#039443", // Text color for the buttons
      },
    },
  },

  modalActionButtons: {
    "& .MuiButton-root": {
      color: "#039443 !important",
      "&:hover": {
        backgroundColor: "rgba(3, 148, 67, 0.1)",
      },
    },
    "& .MuiButton-textPrimary": {
      color: "#039443 !important",
    },
  },
};
